import _ from "lodash";
import {
  PRODUCT_SET_AUDIENCE_BUILDER_PRESET_ADDED_NOT_PURCHASED_DESCRIPTION,
  PRODUCT_SET_AUDIENCE_BUILDER_PRESET_ADDED_NOT_PURCHASED_LABEL,
  PRODUCT_SET_AUDIENCE_BUILDER_PRESET_VIEWED_OR_ADDED_NOT_PURCHASED_DESCRIPTION,
  PRODUCT_SET_AUDIENCE_BUILDER_PRESET_VIEWED_OR_ADDED_NOT_PURCHASED_LABEL,
} from "../i18n/keysTranslations";
import {
  ADS_CAMPAIGN_CUSTOM_EVENT_ADD_TO_CART,
  ADS_CAMPAIGN_CUSTOM_EVENT_CONTENT_VIEW,
  ADS_CAMPAIGN_CUSTOM_EVENT_PURCHASE,
} from "../i18n/keysTranslations";

export const DAYS_OPTIONS = [1, 2, 3, 7, 14, 30, 60, 90, 180];

export const EVENT_OPTIONS = [
  { value: "VIEW_PRODUCT", labelKey: ADS_CAMPAIGN_CUSTOM_EVENT_CONTENT_VIEW },
  { value: "ADD_TO_CART", labelKey: ADS_CAMPAIGN_CUSTOM_EVENT_ADD_TO_CART },
  { value: "PURCHASE", labelKey: ADS_CAMPAIGN_CUSTOM_EVENT_PURCHASE },
];

export const PRESETS = [
  {
    key: "viewedOrAddedNotPurchased",
    labelKey:
      PRODUCT_SET_AUDIENCE_BUILDER_PRESET_VIEWED_OR_ADDED_NOT_PURCHASED_LABEL,
    descriptionKey:
      PRODUCT_SET_AUDIENCE_BUILDER_PRESET_VIEWED_OR_ADDED_NOT_PURCHASED_DESCRIPTION,
    days: 30,
    structure: {
      inclusions: [
        { code: "VIEW_PRODUCT", days: 30 },
        { code: "ADD_TO_CART", days: 30 },
      ],
      exclusions: [{ code: "PURCHASE", days: 30 }],
    },
  },
  {
    key: "addedNotPurchased",
    labelKey: PRODUCT_SET_AUDIENCE_BUILDER_PRESET_ADDED_NOT_PURCHASED_LABEL,
    descriptionKey:
      PRODUCT_SET_AUDIENCE_BUILDER_PRESET_ADDED_NOT_PURCHASED_DESCRIPTION,
    days: 30,
    structure: {
      inclusions: [{ code: "ADD_TO_CART", days: 30 }],
      exclusions: [{ code: "PURCHASE", days: 30 }],
    },
  },
];

const arraysMatch = (arr1, arr2) => {
  if (arr1.length !== arr2.length) return false;
  return arr1.every((item1, index) => {
    const item2 = arr2[index];
    return item1.code === item2.code && item1.days === item2.days;
  });
};

export const detectPreset = (productSetAudience = {}) => {
  if (_.isEmpty(productSetAudience)) return PRESETS[0].key;

  const { inclusions = [], exclusions = [] } = productSetAudience;

  for (const preset of PRESETS) {
    const presetInclusions = preset.structure.inclusions;
    const presetExclusions = preset.structure.exclusions || [];

    if (
      arraysMatch(inclusions, presetInclusions) &&
      arraysMatch(exclusions, presetExclusions)
    ) {
      return preset.key;
    }
  }

  return "custom";
};
